import React from "react";
import { Navigate } from "react-router-dom";
import * as Role from "../Entities/Role";

const homeForRole = (roleId) => {
  switch (roleId) {
    case Role.ADMIN:
      return "/admindashboard";
    case Role.REVIEWER:
      return "/reviewer";
    case Role.USER:
      return "/userdashboard";
    default:
      return "/login";
  }
};

const RoleProtectedRoute = ({ children, allow }) => {
  const token = localStorage.getItem("accessToken");
  const roleId = parseInt(localStorage.getItem("RoleId"), 10);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!allow.includes(roleId)) {
    return <Navigate to={homeForRole(roleId)} replace />;
  }

  return children;
};

export default RoleProtectedRoute;
